import React, { useEffect, useState, useContext } from 'react';
import './Trip.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TextBottom from '@/v2/components/atoms/TextBottom';
import Dialog from '@/v2/components/layouts/Dialog';
import Calendar from '@/v2/components/atoms/Icon/Calendar';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { ConnectivityContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import Fade from '@/v2/components/atoms/Fade/Fade';
import splitTextToEvenLines from '@/v2/components/utils/TextUtils/SplitTextToEvenLines';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const STATE = {
    trip: 'trip',
    transitionNext: 'transitionNext',
};

const videoReady = (controller, onReady) => {
    videoController = controller;
    onReady();
};

const play = () => {
    videoController.Play();
};

const Trip = ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.trip);
    const [{ disclaimer }] = useContext(ConnectivityContext);

    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const handleCta = () => {
        setState(STATE.transitionNext);
        play();
    };

    const videoFinished = () => {
        // delaying execution till video playback finishes
        timeout(onFinished, 800);
    };

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady),
        autoPlay: false,
        onFinished: () => videoFinished(onFinished),
    };

    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    return (
        <div className="Trip">
            <VideoSimple offsetRatio={1.9} offset={100} src={data.video} options={options} />
            <Header show={isActive} hideLogo dark />
            {state !== STATE.transitionNext && (
                <>
                    <TextBottom background="light" animate="in" color="black" component="h4">
                        {splitTextToEvenLines(data.text.text)}
                    </TextBottom>
                    <div className="Trip__dialogbox">
                        <Dialog
                            show={isActive}
                            bodyText={data.dialogbox[0].label.body}
                            bodyTextHeader={data.dialogbox[0].label.title}
                            buttonText={data.dialogbox[0].label.cta}
                            headerRightText={data.dialogbox[0].label.headingRight}
                            headerTitle={data.dialogbox[0].label.headingLeft}
                            headerTitleIcon={<Calendar />}
                            onButtonClick={handleCta}
                        />
                    </div>
                </>
            )}
            {disclaimerContent}

            {/* show = false && disableFadeIn = true will do a fade out animation as soon as scene is active */}
            {isActive && <Fade show={false} slow light cover disableFadeIn />}
        </div>
    );
};

export default Trip;
